export default "__VITE_ASSET__5gSa06pd__"